import { Tooltip } from 'antd'
import { useMemo, useState } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import styled from 'styled-components'
import Popover from '../../../dataDisplay/Popover'

type HeaderCellProps = {
  status: string
  title: string | undefined
}

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 89px;
`

const TitleSpan = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  color: #495057;
`

const HeaderCell = (props: HeaderCellProps) => {
  const { status, title } = props

  const [isclamped, setIsClamped] = useState<boolean | undefined>(undefined)

  const shouldPopoverOpen = !isclamped ? false : undefined

  return (
    <HeaderWrapper>
      <Popover open={shouldPopoverOpen} content={title}>
        <LinesEllipsis
          basedOn="words"
          text={title}
          maxLine={3}
          trimRight
          onReflow={({ clamped }) => setIsClamped(clamped)}
        />
      </Popover>
      <TitleSpan>{status}</TitleSpan>
    </HeaderWrapper>
  )
}

export default HeaderCell
